import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Accessibility = () => {
  return (
    <Container as='main' className='accessibility' id='accessibility'>
      <Row>
        <Col xs={12}>
          <section>
            <h1 className="h1">Barrierefreiheit</h1>
          </section>

          <section>
            <h2 className="h2">Informationen zur Barrierefreiheit</h2>
            <p className="p">
              Notarin Yvonne Luz setzt sich dafür ein, dass alle Menschen ihre digitalen Angebote nutzen können. Dabei
              ist es egal, ob jemand eine Beeinträchtigung hat oder nicht. Frau Luz möchte, dass ihre Webseiten, Apps
              und Online-Dienste für alle einfach zugänglich sind.
            </p>

            <p className="p">
              Frau Luz achtet darauf, dass die höchsten Standards für Barrierefreiheit eingehalten werden. Ziel ist es,
              Hindernisse zu überwinden und allen Menschen die Teilnahme an der digitalen Welt zu ermöglichen.
              Barrierefreiheit ist für Frau Luz ein wichtiger Teil ihrer Verantwortung, um eine inklusive Gesellschaft
              zu fördern.
            </p>
          </section>

          <section>
            <h2 className="h2">Barriere melden</h2>
            <p className="p">
              Haben Sie Fragen oder Anmerkungen zur Barrierefreiheit? Oder ist Ihnen ein Mangel bei der Einhaltung der
              Vorgaben zur Barrierefreiheit aufgefallen? Kontaktieren Sie uns gerne per Mail unter info@ll-notare.de.
            </p>
          </section>

          <section>
            <section>
              <h2 className="h2">Information zur Barrierefreiheit auf ll-notare.de</h2>
            </section>

            <section>
              <h3 className="h3">Allgemeine Beschreibung</h3>
              <p className="p">Die Webseiten dienen primär zur Information über die Produkte und Dienstleistungen von Frau Luz.</p>
            </section>

            <section>
              <h3 className="h3">Stand der Vereinbarkeit und Umsetzung der Anforderungen</h3>
              <p className="p">
                Die Webseiten erfüllen die gesetzlichen Anforderungen zur Barrierefreiheit. Sie entsprechen den
                relevanten Vorgaben aus der EN 301549 und den Web Content Accessibility Guidelines (Stufen A und AA).
              </p>
              <p className="p">
                Zur Umsetzung der Barrierefreiheit wurde die Beratung von erfahrenen Barrierefreiheitsexperten in
                Anspruch genommen.
              </p>
            </section>
          </section>

          <section>
            <section>
              <h2 className="h2">Barrierefreiheitsfunktion</h2>
            </section>

            <section>
              <h3 className="h3">Sehvermögen</h3>
              <p className="p">
                Kontraste, Schriftgröße, Schriftart, Abstände: Die Webseite ist so gestaltet, dass sie auch mit
                eingeschränktem Sehvermögen gut wahrnehmbar ist. Hierauf wurde beispielsweise bei Kontrasten,
                Schriftgröße, Schriftart, Abständen und Zeilenhöhen geachtet.
              </p>

              <p className="p">
                Sie können die Darstellung nach Bedarf mit entsprechenden Mitteln des Betriebssystems Ihres Computers,
                Tablets oder Smartphones anpassen.
              </p>

              <p className="p">
                Alternativen zu Farbhinweisen: Wenn Farbhinweise genutzt werden, gibt es dafür immer eine Alternative,
                die farbunabhängig funktioniert. So wird beispielsweise zum Signalisieren von Zuständen oder bei
                Warnhinweisen ergänzend zur Farbe ein aussagekräftiger Text bereitgestellt.
              </p>
            </section>

            <section>
              <h3 className="h3">Nutzen mit fehlendem Sehvermögen (Blindheit)</h3>
              <p className="p">
                Tastaturbedienbarkeit: Die Webseite ist tastaturbedienbar. Sie können die Funktionen und Bereiche per
                Tastatur erreichen und bedienen.
              </p>

              <p className="p">
                Bildschirmlesefunktion (Screenreader): Sie können Ihren Screenreader zur Nutzung der Webseite einsetzen.
              </p>

              <p className="p">
                Alternativen für mediale Inhalte: Für mediale Inhalte der Webseite werden Alternativen bereitgestellt.
                Beispielsweise:
              </p>

              <ul>
                <li className="li">Alternativtexte für Symbole, Fotos und Grafiken</li>
                <li className="li">Untertitel für Audio- und Videoinhalte</li>
              </ul>

              <p className="p">
                Alternativen zu Farbhinweisen: Wenn Farbhinweise genutzt werden, gibt es dafür immer eine Alternative,
                die kein Sehvermögen voraussetzt. So wird beispielsweise zum Signalisieren von Zuständen oder bei
                Warnhinweisen ergänzend zur Farbe ein aussagekräftiger Text bereitgestellt.
              </p>
            </section>

            <section>
              <h3 className="h3">Hörvermögen</h3>
              <p className="p">
                Die Webseiten sind mit eingeschränktem oder fehlendem Hörvermögen gut nutzbar. Zur Nutzung wird kein
                Hörvermögen vorausgesetzt.
              </p>
            </section>

            <section>
              <h3 className="h3">Beweglichkeit, Reichweite, Kraft</h3>
              <p className="p">
                Die Webseiten sind mit eingeschränkter Beweglichkeit, Reichweite oder Kraft gut nutzbar. Sie können
                dafür Ihre gewohnten eigenen assistiven Technologien einsetzen.
              </p>
            </section>

            <section>
              <h3 className="h3">Sprechvermögen</h3>
              <p className="p">Die Webseiten sind mit eingeschränktem oder fehlendem lautsprachlichen Vermögen gut nutzbar.</p>
            </section>

            <section>
              <h3 className="h3">Kognitiv, Psychisch, Neurologisch, Neurodivergent</h3>
              <p className="p">
                Die Webseiten sind für Menschen mit kognitiven, psychischen oder neurologischen Beeinträchtigungen,
                Störungen oder Behinderungen sowie neurodivergente Menschen gut nutzbar.
              </p>

              <p className="p">
                Klare Strukturen, leicht nutzbar, einfach verständlich: Die Oberfläche der Webseiten ist klar
                strukturiert und leicht nutzbar. Die Beschriftungen für Funktionen wurden so gewählt, dass sie eindeutig
                und einfach verständlich sind.
              </p>

              <p className="p">
                Unterstützung bei der Fehlervermeidung und Fehlerkorrektur: Die Oberfläche der Webseiten ist so
                gestaltet, dass sie Nutzende bei der Fehlervermeidung und Fehlerkorrektur unterstützt.
              </p>

              <p className="p">Gut verständliche Texte: Die Texte werden so gestaltet, dass sie gut verständlich sind.</p>

              <p className="p">
                Verringerte Animationen und Lichteffekte: Bei der Oberfläche der Webseiten wurde darauf geachtet, dass
                auf unnötige Animationen und Licht- /Stroboskopeffekte verzichtet wurde.
              </p>
            </section>

            <section>
              <h3 className="h3">Weitere Angaben zu Benutzerschnittstellen und assistiven Technologien</h3>
              <p className="p">
                Die Funktionen und Benutzerschnittstellen sowie die Unterstützung der assistiven Technologien sind
                barrierefrei entsprechend den Vorgaben.
              </p>

              <p className="p">
                Bei Nutzung der Webseiten können Nutzende ihre eigenen assistiven Technologien nutzen. Die Webseiten
                wurden unter anderem mit folgenden assistiven Technologien geprüft:
              </p>

              <ul>
                <li className="li">
                  Bildschirmvorlese-Software (Screenreader) wie beispielsweise JAWS, NVDA, VoiceOver (iOS), TalkBack
                  (Android).
                </li>
                <li className="li">
                  Vergrößerungssoftware wie beispielsweise Windows Bildschirmlupe, Zoom (iOS-Bedienhilfe), native
                  Vergrößerung (Android).
                </li>
              </ul>
            </section>
          </section>

          <section>
            <h2 className="h2">Zuständige Marktüberwachungsbehörde</h2>
            <p className="p">
              Marktüberwachungsstelle der Länder für die Barrierefreiheit von Produkten und Dienstleistungen (MLBF) in
              Magdeburg, Sachsen-Anhalt.
            </p>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export default Accessibility;
